export const GOOGLE_ANALYTICS_UA = "G-8RVL9GVQ62";
export const GOOGLE_SPEECH_TO_TEXT_API = process.env.REACT_APP_GOOGLE_SPEECH_TO_TEXT_API;
export const VERSION_CODE = 2;
